<template>
  <div :class="$style.containerForm">
    <Modal :statusCode="codeError"
    :type="'recovery'"
    @disable="(vl) => modalShow = vl"
    :showModal="modalShow"
    :toLogin="true" />
    <Loading v-if="load"/>
    <div v-show="firstStep">
      <div :class="$style.containerText">
        <div :class="$style.containertexthNumber">
          <PdsTexting tabindex="0" format="h1" aria-label="Cambia tu clave de acceso, encabezado">
            Cambia tu clave de acceso
          </PdsTexting>
        </div>
        <hr :class="$style.hLine">
      </div>
      <div :class="$style.input">
        <Input
          id="rutCliente"
          label="Ingresa tu RUT de beneficiario"
          :ariaLabel="'Ingresa tu RUT de beneficiario, campo obligatorio'"
          @error="(err) => error.rutClient = err"
          @data="writeRut"
          maxlength="12"
          required
          tabindexipnut="0"
          typeinput="rut"
        />
        <div :class="$style.containerSubForm">
          <VueRecaptcha
            language="es-419"
            :class="$style.recaptchaForeign"
            :sitekey="captchaSiteKey||''"
            :loadRecaptchaScript="true"
            @verify="onCaptchaVerify"
            @expired="onCaptchaExpired"
          />
          <PdsButton
            label="Validar mi RUT"
            role=primary
            tabindex="0"
            aria-label="Validar mi RUT, botón"
            :aria-disabled="validateFirstStep"
            :class="$style.buttonFirst"
            :disabled="validateFirstStep || !captchaConfirmationCode"
            block
            @click="nextStep(1)"
          />
          <div @click="pushBack()">
            <PdsLink
            link="javascript:;"
            aria-label="Regresar al inicio, enlace."
            text="Regresar al inicio"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-show="secondStep">
      <div :class="$style.containerText">
        <div :class="$style.containertexthNumber">
          <PdsTexting format="h1">
            Selecciona un medio para cambiar tu clave
          </PdsTexting>
        </div>
        <hr :class="$style.hLine">
      </div>
      <div :class="$style.radios">
        <Radio
        name="radio"
        id="radioEmail"
        aria-label="por medio de email, radio botón"
        label="Correo electrónico"
        radioValue="email"
        @input="radioSelect('email')"
        value={}
        />
        <div :class="$style.userdata">{{user_email}}</div>
        <Radio
        name="radio"
        id="radioSms"
        aria-label="por medio de mensaje de texto, radio botón"
        label="Mensaje de texto (SMS)"
        radioValue="sms"
        @input="radioSelect('sms')"
        value={}
        />
        <div :class="$style.userdata">{{user_phone}}</div>
      </div>
      <div :class="$style.containerSubForm">
        <PdsButton
          label="Enviar código de cambio de clave"
          role=primary
          aria-label="envíar código de cambio de clave, botón"
          :aria-disabled="validateSecondStep"
          :class="$style.buttonSecond"
          :disabled="validateSecondStep"
          @click="nextStep(radioValue)"
          block
        />
      </div>
    </div>
    <div v-show="thirdSmsStep">
      <div :class="$style.containerText">
        <div :class="$style.containertexthNumber">
          <PdsTexting format="h1">
            Te enviamos un mensaje de texto
          </PdsTexting>
        </div>
        <div :class="$style.containertextsubh">
          <PdsTexting format="body">
            Revisa tus mensajes y luego completa el campo con el código que te enviamos.
          </PdsTexting>
        </div>
        <hr :class="$style.hLine">
      </div>
      <div :class="$style.input">
        <Input
          id="claveCliente"
          label="Ingresa el código de seguridad"
          aria-label="Ingresa el código de seguridad"
          required
          @error="(err) => error.smsCode = err"
          @data="writeSmsCode"
          typeinput="tel"
          maxlength="6"
        />
      </div>
      <div :class="$style.containerSubForm">
        <PdsButton
          label="Crear nueva clave"
          role=primary
          :class="$style.buttonSmsThird"
          :disabled="validateSmsThirdStep"
          @click="nextStep(3)"
          block
        />
      </div>
    </div>
    <div v-show="thirdEmailStep">
      <div :class="$style.containerText">
        <div :class="$style.containertexthNumber">
          <PdsTexting format="h1">
            Te hemos enviado un correo
          </PdsTexting>
        </div>
        <div :class="$style.containertextsubh">
          <PdsTexting format="body">
            Revisa tu correo electrónico y sigue las instrucciones que te enviamos.
          </PdsTexting>
        </div>
        <hr :class="$style.hLine">
      </div>
      <div :class="$style.centerLink" @click="pushBack()">
        <PdsLink
        link="javascript:;"
        aria-label="Regresar al inicio, enlace."
        text="Regresar al inicio"
        />
      </div>
    </div>
    <div v-show="fourthStep">
      <CreatePasswordInput
        title="Ingresa tu nueva clave"
        subTitle="Por seguridad, no podemos usar tu clave anterior,
        por lo que te deberás crear una nueva."
        @data="(pass) => changePassword(pass)"
        :name="userName"
        :typeAccount="'Crear mi nueva clave'"
        rut="111111"
        titleBtn="Crear mi nueva clave"
      />
      <Loading v-if="load"/>
    </div>
  </div>
</template>

<script>
import PdsButton from '@vue-pds/button';
import PdsLink from '@vue-pds/link';
import Input from '@/components/Input';
import VueRecaptcha from 'vue-recaptcha';
import Radio from '@vue-pds/radio';
import PdsTexting from '@vue-pds/texting';
import CreatePasswordInput from '@/components/CreatePasswordInput';
import { mapActions, mapState } from 'vuex';
import types from '@/constants/types';
import Loading from '@/components/Loading';
import Modal from '@/components/Modal';
import gtmRegister from '@/functions/analitics';
import constantsAnalytics from '@/config/constantsAnalytics';

export default {
  name: 'RecoveryPasswordForm',
  components: {
    PdsButton,
    Input,
    VueRecaptcha,
    Radio,
    PdsTexting,
    CreatePasswordInput,
    Loading,
    Modal,
    PdsLink,
  },
  data() {
    return {
      load: false,
      error: {
        rutClient: null,
        smsCode: null,
        reWritePassword: null,
      },
      newPassword: {
        password: null,
        rePassword: null,
      },
      rut: null,
      captchaConfirmationCode: null,
      smsCode: null,
      user_email: '****l@email.com',
      user_phone: '********4567456',
      radioSelected: false,
      radioValue: null,
      firstStep: true,
      secondStep: false,
      thirdSmsStep: false,
      thirdEmailStep: false,
      fourthStep: false,
      userName: '',
      modalShow: false,
      codeError: 200,
    };
  },
  watch: {
    'newPassword.password': {
      handler(value) {
        if (this.newPassword.rePassword !== value) {
          this.error.reWritePassword = 'Contraseñas no coinciden';
        } else {
          this.error.reWritePassword = null;
        }
      },
    },
    'newPassword.rePassword': {
      handler(value) {
        if (this.newPassword.password !== value) {
          this.error.reWritePassword = 'Contraseñas no coinciden';
        } else {
          this.error.reWritePassword = null;
        }
      },
    },
    errorDataPassword(val) {
      if ((val.response !== null || val.isAxiosError) && !this.errorActive) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
    errorVerifyBeneficiarySenEmail(val) {
      if ((val.response !== null || val.isAxiosError) && !this.loadingVerifyBeneficiarySenEmail) {
        this.codeError = val.response ? val.response.status : 0;
        this.modalShow = true;
        this.load = false;
      }
    },
  },
  methods: {
    ...mapActions({
      postRecoveryPassword: types.async.POST_RECOVERY_PASSWORD,
      getVerifyBeneficiarySendEmail: types.async.GET_VERIFY_BENEFICIARY_SEND_EMAIL,
    }),
    radioSelect(value) {
      this.radioValue = value;
      this.radioSelected = true;
    },
    onCaptchaVerify(value) {
      this.captchaConfirmationCode = value;
    },
    onCaptchaExpired() {
      this.captchaConfirmationCode = null;
    },
    login() {
      this.$router.push('/');
    },
    writeRut(rut) {
      this.rutClient = rut;
    },
    writeSmsCode(smsCode) {
      this.smsCode = smsCode;
    },
    nextStep(step) {
      if (step === 1) {
        gtmRegister(constantsAnalytics.recover.btnrecovermail, this);

        this.verifyAndSendEmail();
      }
      if (step === 'sms') {
        this.secondStep = false;
        this.thirdSmsStep = true;
      }
      if (step === 'email') {
        this.secondStep = false;
        this.thirdEmailStep = true;
      }
      if (step === 3) {
        this.thirdSmsStep = false;
      }
    },
    pushBack() {
      gtmRegister(constantsAnalytics.create.pageindex, this);
      this.$router.push('/');
    },
    async changePassword(pass) {
      this.load = true;
      await this.postRecoveryPassword({
        data: {
          newPassword: pass.password,
          token: this.$route.params.token,
        },
      });
      gtmRegister(constantsAnalytics.recover.newpassbtn, this);
      this.login();
      this.load = false;
    },
    async verifyAndSendEmail() {
      this.load = true;
      await this.getVerifyBeneficiarySendEmail({
        rut: parseInt(this.rutClient.value.rut, 10),
        dv: this.rutClient.value.dv,
      });
      this.firstStep = false;
      this.thirdEmailStep = true;

      this.load = false;
    },
  },
  computed: {
    ...mapState({
      postDataPassword: state => state.async[types.actions.POST_RECOVERY_PASSWORD].data || [],
      errorDataPassword: state => state.async[types.actions.POST_RECOVERY_PASSWORD].error,
      errorActive: state => state.async[types.async.LOGIN].loading,
      dataVerifyBeneficiarySendMail:
        state => state.async[types.actions.GET_VERIFY_BENEFICIARY_SEND_EMAIL].data || [],
      errorVerifyBeneficiarySenEmail:
        state => state.async[types.actions.GET_VERIFY_BENEFICIARY_SEND_EMAIL].error,
      loadingVerifyBeneficiarySenEmail:
        state => state.async[types.actions.GET_VERIFY_BENEFICIARY_SEND_EMAIL].loading,
    }),
    captchaSiteKey() {
      return process.env.VUE_APP_CAPTCHA_SITE_KEY;
    },
    validateFirstStep() {
      const errorRut = this.error.rutClient !== null ? this.error.rutClient.error : false;

      if (this.captchaConfirmationCode && (this.rutClient && this.rutClient.value.rut !== '' && this.rutClient.value.rut !== null) && !errorRut) {
        return false;
      }
      return true;
    },
    validateSecondStep() {
      if (this.radioValue === 'sms' || this.radioValue === 'email') {
        return false;
      }
      return true;
    },
    validateSmsThirdStep() {
      if (this.error.smsCode !== null) {
        if (!this.error.smsCode.error) {
          return false;
        }
      }
      return true;
    },
    validateFourthStep() {
      if (this.newPassword.password !== null) {
        if (this.newPassword.password === this.newPassword.rePassword) {
          return false;
        }
      }
      return true;
    },
  },
  created() {
    const valor = JSON.parse(atob(this.$route.params.token));
    if (valor.Rut) {
      this.userName = valor.Name;
      this.firstStep = false;
      this.fourthStep = true;
    }
  },
};
</script>

<style lang="scss" module>
.containerForm {
  width: 600px;
  margin: 0 auto;

  & .containerText {
    padding: 30px 0;

    & .containertextsubh {
      padding: 10px 0 0 0;
      font-size: 22px;
    }

    & .hLine {
      width: 57px;
      height: 3px;
      margin: 25px 0 0 0;
      background: #ffc82e;
      border: 0;
    }
  }

  & .containerSubForm {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 0;

    & .buttonFirst {
      width: 300px;
      height: 42px;
      padding: 14.5px 93px;
      margin: 20px 0;
    }

    & .buttonSecond {
      width: 300px;
      height: 42px;
      padding: 14.5px 36px;
      margin: 20px 0;
    }

    & .buttonSmsThird {
      width: 300px;
      height: 42px;
      padding: 14.5px 83px;
      margin: 20px 0;
    }

    & .buttonFourth {
      width: 300px;
      height: 42px;
      padding: 14.5px 71.5px;
      margin: 20px 0;
    }
  }

  & .radios {
    margin-left: 50px;

    & .userdata {
      margin-left: 50px;
    }
  }

  & .centerLink {
    text-align: center;
  }
}

@media (min-width: 500px) and (max-width: 940px) {
  .containerForm {
    width: auto;

    & .containerText {
      & .containertexthNumber {
        font-size: 40px;
      }
    }
  }
}

@media (max-width: 500px) {
  .containerForm {
    width: auto;

    & .containerText {
      & .containertexthNumber {
        font-size: 35px;
      }
    }
  }
}
</style>
